// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Util from "../../../common/util.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as CountryFlagButton from "./CountryFlagButton.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function CountriesFilter(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("h3", {
                      children: Util.ReactStuff.s("Shopping for someone overseas?"),
                      className: "text-15px ml-4"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        Belt_Array.mapWithIndex(props.countryCategories, (function (i, category) {
                                return JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(CountryFlagButton.make, {
                                                  category: category
                                                }),
                                            className: "w-1/4 sm:w-1/3 mb-3 md:mb-0"
                                          }, "country-" + String(i));
                              })),
                        JsxRuntime.jsx("div", {
                              className: "w-1/4 sm:hidden"
                            })
                      ],
                      className: "flex w-full justify-around mt-2"
                    })
              ],
              className: props.className
            });
}

var make = CountriesFilter;

export {
  make ,
}
/* Util Not a pure module */
